import { render, staticRenderFns } from "./SharingSection.vue?vue&type=template&id=32a291d6&"
import script from "./SharingSection.vue?vue&type=script&lang=ts&"
export * from "./SharingSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports